import api from "../api";
const endpoint = "/volontariat/SQCReponse";
export const SQCReponseService = {
  async insert(data, file_data = null) {
    try {
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));
      if (file_data) {
        formData.append("file", file_data);
      }

      const result = await api.post(endpoint + "/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(data, file_data = null) {
    try {
      //const result = await api.put(endpoint + "/update", filtre);
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));
      if (file_data) {
        formData.append("file", file_data);
      }

      const result = await api.post(endpoint + "/update", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findOneById(id) {
    try {
      const result = await api.get(endpoint + "/find_one", {
        params: { id: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findByQuestionAndCandidat(idQuestion) {
    try {
      const result = await api.get(
        endpoint + "/find_by_question_and_candidat",
        {
          params: {
            id_sqc_question: idQuestion /* id_candidat: idCandidat  */,
          },
        }
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getResume(id_type) {
    try {
      const result = await api.get(endpoint + "/resume_by_lot", {
        params: {
          id_type: id_type /* id_candidat: idCandidat  */,
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getResumeByIDAssociationAndType(id_association, id_type) {
    try {
      const result = await api.get(endpoint + "/resume_by_lot", {
        params: {
          id_type: id_type,
          id_ext_association: id_association,
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getReponsesListByTypeAndFormId(id_type) {
    try {
      const result = await api.get(endpoint + "/find_by_ami", {
        params: {
          id_type: id_type
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async list(filtre) {
    try {
      const result = await api.get(endpoint + "/liste", {
        params: { filtre: filtre },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(id) {
    try {
      const result = await api.post(endpoint + "/delete", id);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
